export enum APITagType {
  SurveyList = 'survey-list',
  AdminSurvey = 'admin-survey',
  BrandOffer = 'brand-offer',
  Company = 'company',
  InsertionOrder = 'insertion-order',
  InvoiceGroup = 'invoice-group',
  MagazineTitle = 'magazine-title',
  PacingView = 'pacing-view',
  PacingBoard = 'pacing-board',
  SuspensionReason = 'suspension-reason',
  YodleeBankAccount = 'yodlee-bank-account',
  YodleeToken = 'yodlee-link-token',
  Summaries = 'summaries',
  MediaPlan = 'media-plan',
  PulsePollingConfig = 'pulse-polling-config',
  OrganizationClients = 'organization-clients',
  ClientExclusions = 'client-exclusions',
  Panel = 'panel',
  CommissionInvoices = 'commission-invoices',
  CommissionPnl = 'commission-pnl',
  CommissionReferrals = 'commission-referrals',
  CommissionReports = 'commission-reports',
  CommissionUsers = 'commission-users',
  CommissionRateOverrides = 'commission-rate-overrides',
  CommissionAdjustments = 'commission-adjustments',
  CommissionSkus = 'commission-skus',
  TrendsEvents = 'trends-events',
  SurveyGroups = 'survey-groups',
  InvoiceLineItemValidation = 'invoice-line-item-validation',
  BillingNeededActions = 'billing-needed-actions',
  BillingDashboard = 'billing-dashboard',
  BillingSku = 'billing-sku',
  SchedulerTasks = 'scheduler-tasks',
  DataJobRuns = 'data-job-runs',
  EtlVerificationPolicy = 'etl-verification-policy',
  LogEntries = 'log-entries',
  OperationsTemplates = 'operations-templates',
  AdTemplates = 'ad-templates',
  VerticalProfiles = 'vertical-profiles',
  CreativeTemplates = 'creative-templates',
  CreativeTemplateExamples = 'creative-template-examples',
  FlowTemplates = 'flow-templates',
  PortalUsers = 'portal-users',
  PortalMetrics = 'portal-metrics',
  PortalSubscriptions = 'portal-subscriptions',
  PortalWorkspaces = 'portal-workspaces',
  UserJourney = 'user-journey',
  ActivityInsights = 'activity-insights',
  ActivityInsightsUsers = 'activity-insights-users',
  PortalSchedulingConnections = 'portal-scheduling-connections',
  PortalSchedulingRequests = 'portal-scheduling-requests',
  PortalSchedulingSettings = 'portal-scheduling-settings',
  LaunchedCampaigns = 'launched-campaigns',
  ClientCampaignAccess = 'client-campaign-access',
  CampaignEmailSchedules = 'campaign-email-schedules',
  ClientDataTransfers = 'client-data-transfers',
  DataTransferRuns = 'data-transfer-runs',
}

export type TagProviderResult = {
  readonly id: string;
  readonly type: APITagType;
};

export type TagInvalidator = APITagType | { id: string, type: APITagType };
